var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
// List Service - Makes direct API calls for list operations
import config from "../config";
class ListService {
    constructor() {
        this.baseURL = config.API_URL;
    }
    getUserLists(userId, token) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!token)
                throw new Error("No authentication token");
            const response = yield fetch(`${this.baseURL}/lists/createdBy/${userId}`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    "Content-Type": "application/json",
                },
            });
            if (!response.ok) {
                throw new Error(`Failed to get lists: ${response.status} ${response.statusText}`);
            }
            const data = yield response.json();
            return { lists: data.lists || [] };
        });
    }
    createList(name, token) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                if (!token)
                    throw new Error("No authentication token");
                const response = yield fetch(`${this.baseURL}/lists`, {
                    method: "POST",
                    headers: {
                        Authorization: `Bearer ${token}`,
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify({ name }),
                });
                if (!response.ok) {
                    throw new Error(`Failed to create list: ${response.statusText}`);
                }
                const list = yield response.json();
                return { success: true, list };
            }
            catch (error) {
                console.error("Error creating list:", error);
                return { success: false, error: error.message };
            }
        });
    }
    updateList(id, name, token) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                if (!token)
                    throw new Error("No authentication token");
                const response = yield fetch(`${this.baseURL}/lists/${id}`, {
                    method: "PUT",
                    headers: {
                        Authorization: `Bearer ${token}`,
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify({ name }),
                });
                if (!response.ok) {
                    throw new Error(`Failed to update list: ${response.statusText}`);
                }
                const list = yield response.json();
                return { success: true, list };
            }
            catch (error) {
                console.error("Error updating list:", error);
                return { success: false, error: error.message };
            }
        });
    }
    deleteCandidates(candidateIds, token) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                if (!token)
                    throw new Error("No authentication token");
                const response = yield fetch(`${this.baseURL}/lists/candidates/delete`, {
                    method: "POST",
                    headers: {
                        Authorization: `Bearer ${token}`,
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify({ candidateIds }),
                });
                if (!response.ok) {
                    throw new Error(`Failed to delete contacts: ${response.statusText}`);
                }
                const { deletedCount } = (yield response.json());
                return { success: true, deletedCount };
            }
            catch (error) {
                console.error("Error deleting contacts:", error);
                return { success: false, error: error.message };
            }
        });
    }
    deleteList(id, token) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                if (!token)
                    throw new Error("No authentication token");
                const response = yield fetch(`${this.baseURL}/lists/${id}`, {
                    method: "DELETE",
                    headers: {
                        Authorization: `Bearer ${token}`,
                        "Content-Type": "application/json",
                    },
                });
                if (!response.ok) {
                    throw new Error(`Failed to delete list: ${response.statusText}`);
                }
                const { success } = (yield response.json());
                if (!success) {
                    throw new Error("List not found or it belongs to another organization");
                }
                return { success: true };
            }
            catch (error) {
                console.error("Error deleting list:", error);
                return { success: false, error: error.message };
            }
        });
    }
    getCandidateLists(linkedInId, token) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                if (!token)
                    throw new Error("No authentication token");
                const response = yield fetch(`${this.baseURL}/lists/candidate/${linkedInId}`, {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        "Content-Type": "application/json",
                    },
                });
                if (!response.ok) {
                    throw new Error(`Failed to get candidate lists: ${response.statusText}`);
                }
                const data = yield response.json();
                return { listIds: data.listIds || [] };
            }
            catch (error) {
                console.error("Error getting candidate lists:", error);
                return { listIds: [] };
            }
        });
    }
    setCandidateLists(linkedInId, listIds, token) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                if (!token)
                    throw new Error("No authentication token");
                const response = yield fetch(`${this.baseURL}/lists/candidate/${linkedInId}`, {
                    method: "PUT",
                    headers: {
                        Authorization: `Bearer ${token}`,
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify({ listIds }),
                });
                if (!response.ok) {
                    throw new Error(`Failed to set candidate lists: ${response.statusText}`);
                }
                return { success: true };
            }
            catch (error) {
                console.error("Error setting candidate lists:", error);
                return { success: false };
            }
        });
    }
    addCandidateToList(linkedInId, listId, token) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                if (!token)
                    throw new Error("No authentication token");
                const response = yield fetch(`${this.baseURL}/lists/candidate/add`, {
                    method: "POST",
                    headers: {
                        Authorization: `Bearer ${token}`,
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify({ linkedInId, listId }),
                });
                if (!response.ok) {
                    throw new Error(`Failed to add candidate to list: ${response.statusText}`);
                }
                return { success: true };
            }
            catch (error) {
                console.error("Error adding candidate to list:", error);
                return { success: false, error: error.message };
            }
        });
    }
    removeCandidateFromList(linkedInId, listId, token) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                if (!token)
                    throw new Error("No authentication token");
                const response = yield fetch(`${this.baseURL}/lists/candidate/remove`, {
                    method: "POST",
                    headers: {
                        Authorization: `Bearer ${token}`,
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify({ linkedInId, listId }),
                });
                if (!response.ok) {
                    throw new Error(`Failed to remove candidate from list: ${response.statusText}`);
                }
                return { success: true };
            }
            catch (error) {
                console.error("Error removing candidate from list:", error);
                return { success: false, error: error.message };
            }
        });
    }
    createListWithCandidates(listName, candidateIds, token) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                if (!token)
                    throw new Error("No authentication token");
                const response = yield fetch(`${this.baseURL}/lists/with-candidates`, {
                    method: "POST",
                    headers: {
                        Authorization: `Bearer ${token}`,
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify({ name: listName, candidateIds }),
                });
                if (!response.ok) {
                    throw new Error(`Failed to create list with candidates: ${response.statusText}`);
                }
                const data = yield response.json();
                return Object.assign({ success: true }, data);
            }
            catch (error) {
                console.error("Error creating list with candidates:", error);
                return { success: false, error: error.message };
            }
        });
    }
}
export const listService = new ListService();
export default listService;
